import { Navigate } from "react-router-dom";

export default function AuthGuardRedirect() {
  const saved = localStorage.getItem("auth");
  let auth = null;

  if (saved) {
    try {
      auth = JSON.parse(saved);
    } catch {
      // bad data in storage; clear it
      localStorage.removeItem("auth");
      auth = null;
    }
  }

  if (auth?.passwordResetRequired) {
    return <Navigate to="/authentication/reset-password" replace />;
  }

  if (auth?.token) {
    return <Navigate to="/dashboard" replace />;
  }

  return <Navigate to="/authentication/sign-in" replace />;
}
